/**
 * Every localStorage / sessionStorage key the app uses. Add new keys here instead of inline
 * strings (cmps scattered 'u_d', 'otp-left', 'organizationRegister.*' across components).
 * Never store tokens or personal data: MSAL owns its own cache.
 */
export const STORAGE_KEYS = {
  /** Persisted Redux slices (see app/store/persistence.ts). Bump the version on breaking changes. */
  appState: 'permione:state:v1',
} as const;
